import { db } from "../firebase-config";
import { 
    collection, 
    doc, 
    setDoc, 
    serverTimestamp, 
    query,
    orderBy,
    getDocs,
    deleteDoc,
    updateDoc,
    getDoc
} from "firebase/firestore";

export const createThread = async (userId, message) => {
    const threadsRef = collection(db, "Users", userId, "threads");
    const newThreadRef = doc(threadsRef);
    
    // Extract first line or first few words for initial title
    const initialTitle = message.content
        .split(/[.!?]/)[0]  // Get first sentence
        .substring(0, 50)   // Limit length
        .trim() + "...";    // Add ellipsis
    
    await setDoc(newThreadRef, {
        title: initialTitle,
        created_at: serverTimestamp(),
        updated_at: serverTimestamp(),
        messages: [{
            text: message.content,
            from: message.role,
            timestamp: new Date().toISOString()
        }]
    });

    return newThreadRef.id;
};

export const addMessageToThread = async (userId, threadId, message) => {
    const threadRef = doc(db, "Users", userId, "threads", threadId);
    
    // Get current thread data
    const threadDoc = await getDoc(threadRef);
    const threadData = threadDoc.data();
    console.log('Current thread data:', threadData);
    
    const currentMessages = threadData.messages || [];
    console.log('Current message count:', currentMessages.length);
    
    const updatedMessages = [...currentMessages, {
        text: message.content,
        from: message.role,
        timestamp: new Date().toISOString()
    }];
    console.log('Updated messages length:', updatedMessages.length);

    // First update the messages
    await updateDoc(threadRef, {
        updated_at: serverTimestamp(),
        messages: updatedMessages
    });
    console.log('Thread updated with new message');

    // If this is the second message, generate and update the title
    if (updatedMessages.length === 2) {
        await generateAndUpdateTitle(userId, threadId, updatedMessages);
    }
};

// Helper function to handle title generation and update
const generateAndUpdateTitle = async (userId, threadId, messages) => {
    console.log('Attempting to generate title for thread:', threadId);
    const maxRetries = 3;
    let retryCount = 0;
    
    while (retryCount < maxRetries) {
        try {
            console.log('Making title generation request, attempt:', retryCount + 1);
            const response = await fetch('/api/generateTitle', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    messages: messages.map(msg => ({
                        text: msg.text,
                        from: msg.from
                    })),
                    userId,
                    threadId
                })
            });
            
            console.log('Title generation response status:', response.status);
            if (response.ok) {
                const result = await response.json();
                console.log('Successfully generated title:', result.title);
                
                // Update the title in Firestore
                const threadRef = doc(db, "Users", userId, "threads", threadId);
                await updateDoc(threadRef, {
                    title: result.title,
                    updated_at: serverTimestamp()
                });
                console.log('Title updated in Firestore');
                return;
            }
            
            const errorText = await response.text();
            console.error('Error response body:', errorText);
            throw new Error(`Failed to generate title: ${errorText}`);
        } catch (error) {
            console.error(`Error generating title (attempt ${retryCount + 1}/${maxRetries}):`, error);
            retryCount++;
            
            if (retryCount === maxRetries) {
                console.error('Failed to generate title after all retries');
            } else {
                console.log(`Waiting ${Math.pow(2, retryCount)} seconds before retry`);
                await new Promise(resolve => setTimeout(resolve, Math.pow(2, retryCount) * 1000));
            }
        }
    }
};

export const getThreads = async (userId) => {
    const threadsRef = collection(db, "Users", userId, "threads");
    const q = query(threadsRef, orderBy("updated_at", "desc"));
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    }));
};

export const deleteThread = async (userId, threadId) => {
    const threadRef = doc(db, "Users", userId, "threads", threadId);
    await deleteDoc(threadRef);
};

export const renameThread = async (userId, threadId, newTitle) => {
    const threadRef = doc(db, "Users", userId, "threads", threadId);
    await updateDoc(threadRef, {
        title: newTitle,
        updated_at: serverTimestamp()
    });
}; 